import { render, staticRenderFns } from "./pay-multiple.vue?vue&type=template&id=10df0b7e&scoped=true&"
import script from "./pay-multiple.vue?vue&type=script&setup=true&lang=js&"
export * from "./pay-multiple.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./pay-multiple.vue?vue&type=style&index=0&id=10df0b7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10df0b7e",
  null
  
)

export default component.exports